__turbopack_context__.v({
  "cta": "XvDg5W_cta",
  "ctaIcon": "XvDg5W_ctaIcon",
  "excerpt": "XvDg5W_excerpt",
  "linkText": "XvDg5W_linkText",
  "logo": "XvDg5W_logo",
  "text": "XvDg5W_text",
  "tile": "XvDg5W_tile",
});
